// extracted by mini-css-extract-plugin
module.exports = {"root":"_35GZP","line":"xf_cT"};